import React, { FunctionComponent, CSSProperties } from 'react';
import Icon from '../Icon';
import styles from './styles.module.scss';
import { concat } from '../../common/helpers/arrayHelper';

interface IProps {
  percent: number;
  variant?: 'primary' | 'secondary';
}

const Star: FunctionComponent<IProps> = ({ percent, variant = 'primary' }) => (
  <div className={styles.starWrapper}>
    <div
      style={{ '--percent': `${percent}%` } as CSSProperties}
      className={concat(
        styles.star,
        'star d-flex justify-content-center align-items-center',
        variant === 'primary' ? styles.primary : styles.secondary
      )}
    >
      <Icon icon="inactiveStar" className={styles.icon} />
    </div>
  </div>
);

export default Star;
